module.exports = __webpack_public_path__ + "img/west-vvip-layout.d0e79b1e.jpg";